import React from 'react';

/**
 * Inline workshop-role selector for member lists. `owner` is shown but never
 * selectable (assigned once at tenant creation, immutable). Disable the whole
 * control via `disabled` (inactive account, platform admin, or owner row).
 *
 * Custom compact `<select>` (not the shared `Select`) to keep the dense
 * pill look used across member lists.
 */
export interface UserRoleSelectProps {
  role: string;
  onChange: (role: string) => void;
  disabled?: boolean;
}

const UserRoleSelect: React.FC<UserRoleSelectProps> = ({ role, onChange, disabled }) => (
  // architecture-check-disable-next-line — compact inline role pill, not a form field
  <select
    value={role}
    disabled={disabled}
    onChange={(e) => onChange(e.target.value)}
    onClick={(e) => e.stopPropagation()}
    className={`px-2 py-1 rounded-lg text-[10px] font-bold uppercase tracking-widest border border-border-subtle dark:border-border-subtle-dark bg-white dark:bg-surface-dark text-slate-600 dark:text-slate-300 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all disabled:opacity-50${
      disabled ? ' opacity-40' : ''
    }`}
  >
    <option value="owner" disabled>Propietario</option>
    <option value="admin">Admin</option>
    <option value="worker">Trabajador</option>
    <option value="viewer">Solo lectura</option>
  </select>
);

export default UserRoleSelect;
